import gql from 'graphql-tag'

export default gql`
query activityLogsPagination(
  $filter: FilterFindManyActivityLogInput
  $sort: SortFindManyActivityLogInput
  $page: Int
  $perPage: Int
) {
  activityLogsPagination(filter: $filter, sort: $sort, page: $page, perPage: $perPage) {
    count
    items {
      _id
      action
      eventId
      actorId
      actorName
      actorRole
      activityId
      participantId
      bib
      activityStatus
      activityCreatedAt
      snapshot
      snapshotTruncated
      batchId
      reason
      source
      deleteConfirmed
      deletedAt
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
`
